import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';
import { BlogPage } from  './../blog-page';

@Component({
  selector: 'super-sized-shipping',
  template: require('./super-sized-shipping.component.html'),
  styles: [require('./../blog.component.scss'), require('./super-sized-shipping.component.scss')]
})
export class SuperSizedShippingComponent extends BlogPage {
  title = "5 Outcomes of Super-Sizing the Shipping Industry - Linescape";
  description = "The global container shipping sector has consolidated to the point that today the five biggest ocean-container lines control about 60% of the global shipping market.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/blog/super-sized-shipping/super-sized-shipping.component.ts